import { styled } from '@project44/manifest-ds';

export const Wrapper = styled('div', {
  height: '100%',
  width: '100%',

  '.mapboxgl-popup-content': {
    background: '$palette-grey-800',
    borderRadius: '$small',
    padding: '$medium',
  },

  '.mapboxgl-popup-anchor-top, .mapboxgl-popup-anchor-top-left, mapboxgl-popup-anchor-top-right':
    {
      '.mapboxgl-popup-tip': {
        borderBottomColor: '$palette-grey-800',
      },
    },
  '.mapboxgl-popup-anchor-bottom, .mapboxgl-popup-anchor-bottom-left, .mapboxgl-popup-anchor-bottom-right':
    {
      '.mapboxgl-popup-tip': {
        borderTopColor: '$palette-grey-800',
      },
    },
  '.mapboxgl-popup-anchor-left .mapboxgl-popup-tip': {
    borderRightColor: '$palette-grey-800',
  },
  '.mapboxgl-popup-anchor-right .mapboxgl-popup-tip': {
    borderLeftColor: '$palette-grey-800',
  },
});
